import createContextExtractor from './createContextExtractor';
import hasApiErrors from './hasApiErrors';
import hasErrors from './hasErrors';
import { connect } from 'react-redux';
/**
* Create a submit element which can be used as a react component
* @param {string} Submit - component to be decorated
* @return {function} function which accepts field component to be decorated
*/

export default function connectSubmit(Submit) {
  return createContextExtractor('Submit')(connect(function (state, _ref) {
    var disabled = _ref.disabled,
      onionFormName = _ref.onionFormName;
    var anyValidationErrors = hasErrors(state, onionFormName);
    var anyApiErrors = hasApiErrors(state, onionFormName);
    return {
      disabled: anyValidationErrors || !!disabled,
      hasErrors: anyValidationErrors || anyApiErrors,
      onionForm: state.onionForm.getIn(['fields', onionFormName])
    };
  }, function (state, _ref2) {
    var _onClick = _ref2.onClick,
      onionOnSubmit = _ref2.onionOnSubmit;
    return {
      onClick: function onClick(event) {
        return onionOnSubmit(event) && typeof _onClick === 'function' && _onClick(event);
      }
    };
  })(Submit));
}